import * as React from 'react';

const SvgCheckCircle = (props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99996 18.6546C14.6023 18.6546 18.3333 14.9237 18.3333 10.3213C18.3333 5.71894 14.6023 1.98798 9.99996 1.98798C5.39759 1.98798 1.66663 5.71894 1.66663 10.3213C1.66663 14.9237 5.39759 18.6546 9.99996 18.6546ZM13.8266 8.20505C14.0386 7.93258 13.9895 7.53991 13.717 7.32799C13.4445 7.11607 13.0519 7.16516 12.84 7.43763L9.50078 11.7308C9.42653 11.8263 9.28687 11.8387 9.19697 11.7578L7.08473 9.85678C6.82817 9.62587 6.43298 9.64667 6.20207 9.90324C5.97116 10.1598 5.99196 10.555 6.24853 10.7859L8.36076 12.6869C8.99004 13.2533 9.96771 13.1665 10.4875 12.4983L13.8266 8.20505Z"
      fill="#699AFF"
    />
  </svg>
);

export default SvgCheckCircle;
